import { Link as RouterLink, useHistory, useLocation } from 'react-router-dom';
import * as React from 'react';
import { closeDialog, DialogRoute, mergeQueryString } from 'bernie-core';
import { Layer } from 'bernie-view';
import { useLocalization } from '@shared-ui/localization-context';
import { UitkToolbar } from 'uitk-react-toolbar';
import { UitkDialogContent, UitkDialogFooter, UitkFullscreenDialog } from 'uitk-react-dialog';
import { UitkLink } from 'uitk-react-link';
import { UitkSheetTransition } from 'uitk-react-sheet';
import { UitkText } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
import { useStores } from '../../utils/hooks';
export var ActivityMessageDialog = function (_a) {
  var activityMessageAction = _a.activityMessageAction;
  var analytics = useStores().analytics;
  var history = useHistory();
  var location = useLocation();
  var formatText = useLocalization().formatText;
  var clickAction = activityMessageAction.clickAction;
  var uniqueDialogId = 'activity-message-dialog';
  var onDismiss = function () {
    var _a, _b;
    if ((_a = clickAction.dismissAction) === null || _a === void 0 ? void 0 : _a.rfrr) {
      analytics.trackEvent((_b = clickAction.dismissAction) === null || _b === void 0 ? void 0 : _b.rfrr, 'RFRR Action Link', analytics.omnitureData, null, true);
    }
    closeDialog({
      history: history,
      location: location
    });
  };
  return React.createElement(React.Fragment, null, React.createElement(DialogRoute, {
    id: uniqueDialogId
  }, React.createElement(UitkSheetTransition, {
    isVisible: true
  }, React.createElement(Layer, {
    id: "activity-message-dialog",
    onDismiss: onDismiss
  }, React.createElement(UitkFullscreenDialog, {
    dialogShow: true
  }, React.createElement(UitkToolbar, {
    toolbarTitle: clickAction.title ? clickAction.title : '',
    navigationContent: {
      navType: 'close',
      onClick: onDismiss,
      navButtonId: 'UitkToolbar',
      navIconLabel: 'Close the dialog'
    }
  }), React.createElement(UitkDialogContent, null, React.createElement(UitkText, {
    size: 300
  }, clickAction.messages.map(function (value, index) {
    return React.createElement(UitkText, {
      spacing: "two",
      key: index
    }, value);
  }))), React.createElement(UitkSpacing, {
    padding: {
      blockend: 'six',
      inline: 'six'
    }
  }, React.createElement("div", null, React.createElement(UitkDialogFooter, {
    buttonOne: {
      onClick: onDismiss,
      text: formatText('lx.search.form.close'),
      type: 'tertiary'
    }
  }))))))), React.createElement(UitkLink, {
    inline: true
  }, React.createElement(RouterLink, {
    to: {
      pathname: location.pathname,
      search: mergeQueryString(location.search, {
        pwaDialog: uniqueDialogId
      })
    },
    role: "button"
  }, activityMessageAction.text)));
};